import React from "react";
import { WelcomePage, LoginPage, PasswordPage, CreateConferencePage } from "../pages";
import { Switch, Route } from "react-router-dom";
import { RoutePath } from "../models/enums";
import Redirect from "./redirect";
import Loader from "./loader";
import ErrorMessage from "./errorMessage";
import { Office } from "common";
import getErrorIsNotOutlook from "taskpane/resources/getErrorIsNotOutlook";
import { useLoading } from "../providers/loadingProvider";
import "../styles/app.css";

export interface IApp {
  host: Office.HostType;
}

const App: React.FC<IApp> = ({ host }: IApp): React.JSX.Element => {
  const { loading } = useLoading();

  if (host !== Office.HostType.Outlook) {
    return <ErrorMessage errorText={getErrorIsNotOutlook()} />;
  }

  return (
    <div className="mainContainer">
      {loading ? <Loader /> : null}

      <Switch>
        <Route exact path={RoutePath.root} component={Redirect} />
        <Route path={RoutePath.welcomePage}>
          <WelcomePage />
        </Route>
        <Route path={RoutePath.loginPage}>
          <LoginPage />
        </Route>
        <Route path={RoutePath.passwordPage}>
          <PasswordPage />
        </Route>
        <Route path={RoutePath.conferencePage}>
          <CreateConferencePage />
        </Route>
        <Route component={Redirect} />
      </Switch>
    </div>
  );
};

export default App;
